<template>
  <div
    :class="$style.container"
    v-text="title"
  />
</template>

<script>
export default {
  name: 'ScreenTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type('redular', 20, 60)
</style>
